import { connect } from 'react-redux';
import MiniIcon from 'app/commonComponents/miniIcon/miniIcon';

const mapStateToProps = ({ miniWishlist }) => ({
  totalItems: miniWishlist.totalItems,
});

export default connect(mapStateToProps)(MiniIcon);
